// Which physical edge the nav rail clings to, derived from device orientation.
// The banner is "glued" to the device's top edge: upright = top, rotated CCW =
// left, rotated CW = right, upside-down = bottom.
//
// CALIBRATION: the Screen Orientation API labels the two landscape states
// "primary" and "secondary", but which one corresponds to a counter-clockwise
// turn is device-dependent. This single constant maps landscape-primary to a
// side; flip it if rotating CCW (top edge to the left) lands on the wrong side.
export const LANDSCAPE_PRIMARY_SIDE = 'left'; // 'left' | 'right'

// On-screen orientation readout, used only to calibrate the constant above.
// Flip to true to recalibrate on a new device.
export const SHOW_RAIL_DEBUG = false;

const otherSide = (s) => (s === 'left' ? 'right' : 'left');

// Raw orientation details, for the calibration readout.
export function getOrientationInfo() {
  if (typeof window === 'undefined') return { type: 'n/a', angle: null, source: 'none' };
  const so = window.screen && window.screen.orientation;
  if (so && so.type) return { type: so.type, angle: so.angle, source: 'screen.orientation' };
  if (typeof window.orientation === 'number') {
    return { type: 'window.orientation', angle: window.orientation, source: 'window.orientation' };
  }
  const landscape = window.matchMedia && window.matchMedia('(orientation: landscape)').matches;
  return { type: landscape ? 'landscape' : 'portrait', angle: null, source: 'matchMedia' };
}

// Returns 'top' | 'left' | 'right' | 'bottom'.
export function computeRail() {
  if (typeof window === 'undefined') return 'top';
  const so = window.screen && window.screen.orientation;
  if (so && so.type) {
    if (so.type.startsWith('portrait')) {
      return so.type === 'portrait-secondary' ? 'bottom' : 'top';
    }
    return so.type === 'landscape-primary'
      ? LANDSCAPE_PRIMARY_SIDE
      : otherSide(LANDSCAPE_PRIMARY_SIDE);
  }
  // Older iOS fallback (deprecated window.orientation).
  if (typeof window.orientation === 'number') {
    const o = window.orientation;
    if (o === 180) return 'bottom';
    if (o === 90) return LANDSCAPE_PRIMARY_SIDE;
    if (o === -90) return otherSide(LANDSCAPE_PRIMARY_SIDE);
    return 'top';
  }
  // Last resort: orientation only, no direction. Default landscape to the
  // calibrated primary side.
  if (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) {
    return LANDSCAPE_PRIMARY_SIDE;
  }
  return 'top';
}
